module.exports = __webpack_public_path__ + "img/weixinkefu.f692cb99.png";